import { cn } from '../lib/cn';

// A zero bucket draws a 1px line, never nothing: a gap reads as "no data" instead of "nothing failed then".
export type TSparkTone = 'danger' | 'motion' | 'muted';

const FILL: Record<TSparkTone, string> = {
  danger: 'bg-danger',
  motion: 'bg-motion',
  muted: 'bg-faint',
};

const HEIGHT = {
  spark: 'h-spark',
  card: 'h-spark-card',
  chart: 'h-spark-chart',
} as const;

const GAP = { 1: 'gap-px', 2: 'gap-hair', 3: 'gap-tight' } as const;

interface ISparklineProps {
  values: readonly number[];
  tone: TSparkTone;
  height: keyof typeof HEIGHT;
  gap?: keyof typeof GAP;
  label: string;
  className?: string;
}

export const Sparkline = ({ values, tone, height, gap = 1, label, className }: ISparklineProps) => {
  const peak = Math.max(0, ...values);

  return (
    <div
      role="img"
      aria-label={label}
      className={cn('flex items-end', HEIGHT[height], GAP[gap], className)}
    >
      {values.map((value, index) => {
        const empty = peak <= 0 || value <= 0;
        return (
          <span
            // Buckets are positional and unlabelled; the index IS the identity.
            key={index}
            className={cn(
              'flex-1',
              empty ? 'h-px bg-border-sunken' : cn('rounded-bar', FILL[tone]),
            )}
            style={empty ? undefined : { height: `${(value / peak) * 100}%` }}
          />
        );
      })}
    </div>
  );
};
